import { use, createContext, useCallback, useMemo } from 'react'
import { useToastAlert } from '@kenect-ut/kenect-ui-kit'
import axios from 'axios'
import PropTypes from 'prop-types'

export const ToastAlertContext = createContext({})
export const ToastAlertContextProvider = ({ children }) => {
  const [toastAlert, showAlert] = useToastAlert('#root')

  const showAxiosAlert = useCallback(
    (message, options = {}) => {
      const { error, toastOptions } = options
      const colors = ['blue', 'green', 'orange', 'red']
      const nextOptions = {
        color: 'red', // default, but should be override-able,
        isDarkMode: false,
        ...toastOptions,
      }
      const colorError = `showAxiosAlert()'s toastOptions color property must be a string of one of the following: '${colors.join("', '")}'.`

      if (error && axios.isCancel(error)) {
        return
      } else if (toastOptions?.color && !colors.includes(toastOptions.color)) {
        return console.warn(colorError)
      }

      showAlert(message, nextOptions)
    },
    [showAlert],
  )

  const context = useMemo(
    () => ({
      showAxiosAlert,
      showAlert,
    }),
    [showAxiosAlert, showAlert],
  )

  return (
    <>
      <ToastAlertContext value={context}>{children}</ToastAlertContext>
      {toastAlert}
    </>
  )
}

export const useToastAlertContext = () => use(ToastAlertContext)

ToastAlertContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf([PropTypes.node]),
  ]).isRequired,
}
